import GameScoreUnity from './GameScoreUnity'

window.GameScoreUnity = GameScoreUnity;
